import { useGetPagesQuery } from 'api/siteApi';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isReady } from '../store/bootstrapSlice';
import {
  getSelectedSiteCollaborateInfo,
  getSelectedSiteId,
} from '../store/siteInfoSlice';
import { setPageLoading } from '../store/uiSlice';
import { useTasksNew } from './use-tasks-new';

export const useSidebarLoading = () => {
  const dispatch = useDispatch();
  const siteId = useSelector(getSelectedSiteId);
  const bootstrapReady = useSelector(isReady);
  const collaborateInfo = useSelector(getSelectedSiteCollaborateInfo);

  // Get loading states from various hooks
  const { isLoading: isLoadingTasks, isSuccess: isTasksSuccess } =
    useTasksNew();
  const { isLoading: isLoadingPages, isSuccess: isPagesSuccess } =
    useGetPagesQuery({ siteId: siteId || '' }, { skip: !siteId });

  useEffect(() => {
    // Check if we have a siteId and all data is loaded
    const isBootstrapReady = bootstrapReady === 'success';
    const isSiteReady = !!siteId;
    const isCollaborateInfoReady = !!collaborateInfo;
    const isTasksReady = !isLoadingTasks && isTasksSuccess;
    const isPagesReady = !isLoadingPages && isPagesSuccess;

    // Only hide loading when all conditions are met
    if (
      isBootstrapReady &&
      isSiteReady &&
      isCollaborateInfoReady &&
      isTasksReady &&
      isPagesReady
    ) {
      // Add a small delay to ensure UI is fully rendered
      const timer = setTimeout(() => {
        dispatch(setPageLoading(false));
      }, 500);

      return () => clearTimeout(timer);
    } else {
      // Show loading if any condition is not met
      dispatch(setPageLoading(true));
    }
  }, [
    dispatch,
    bootstrapReady,
    siteId,
    collaborateInfo,
    isLoadingTasks,
    isTasksSuccess,
    isLoadingPages,
    isPagesSuccess,
  ]);

  // Reset loading state when siteId changes
  useEffect(() => {
    if (siteId) {
      dispatch(setPageLoading(true));
    }
  }, [dispatch, siteId]);
};
